import React, { useState } from "react";
import { Actions as DEPUTY_ACTIONS } from './store/deputyActions';
import { connect } from "react-redux"
import Spinner from "../../common/Spinner";
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import ReactDatePicker from "react-datepicker";
import { DateInputFormat } from "../../common/DateComponents";
import { addYears, subYears } from "date-fns";

const DeputyImport = ({
  importData,
  importing
}) => {

  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return new Date(firstDayOfMonth.getTime() - (firstDayOfMonth.getTimezoneOffset() * 60000));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return new Date(lastDayOfMonth.getTime() - (lastDayOfMonth.getTimezoneOffset() * 60000));
  });


  return (
    <div>
      <div className="row">
        <h5>Import Timesheets from Deputy</h5>
        <div className="col-xs-7 pl-0">

          <div className="col-xs-6 pl-0">
            <label>From</label>
            <ReactDatePicker
              selected={startDate}
              onChange={(date) => {
                if (date) setStartDate(date)
              }}
              minDate={subYears(new Date(), 10)}
              maxDate={addYears(new Date(), 10)}
              dateFormat="dd/MM/yyyy"
              customInput={<DateInputFormat />}
            />
            {/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
            <div className="clearfix" />
          </div>
          <div className="col-xs-6 pl-0">
            <label htmlFor=" ">To</label>
            <ReactDatePicker
              selected={endDate}
              onChange={(date) => {
                if (date) setEndDate(date)
                if (startDate > date) setStartDate(date)
              }}
              minDate={subYears(new Date(), 10)}
              maxDate={addYears(new Date(), 10)}
              dateFormat="dd/MM/yyyy"
              customInput={<DateInputFormat />}
            />
            <div className="clearfix" />
          </div>

          <div className="clearfix" />

        </div>

        <div className="col-xs-5 pr-0" style={{ marginTop: 23 }}>
          <button
            className='btn btn-default'
            onClick={() => importData(startDate, endDate)}
          >
            {importing ?
              <Spinner
                style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
                className="animate-spin -ml-1 mr-3 h-5 w-5 "
              />
              :
              <ArrowDownTrayIcon
                style={{ height: "1.5em", float: "left", marginRight: 5 }}
              />
            }
            <div style={{ float: "left" }}>
              {importing ? 'Importing...' : 'Import From Deputy'}
            </div>
          </button>
        </div>
      </div>

    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    importing: !!state.deputy?.importing
  }
}

const mapDispatchToProps = dispatch => ({
  importData: (start, end) => dispatch(DEPUTY_ACTIONS.importData(start, end)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeputyImport)
